import { Badge, Group } from '@mantine/core';
import { useHistory } from 'react-router';
import { isEmpty } from 'remeda';
import type { UsedByResource } from 'shared/hooks/use-load-template-v2';

type TemplateUsedByPillsProps = {
  planType: string;
  usedBy: UsedByResource[];
};

export const TemplateUsedByPills = ({ planType, usedBy }: TemplateUsedByPillsProps) => {
  const history = useHistory();

  if (isEmpty(usedBy)) return null;

  const goToUsedByResource = (resource: UsedByResource) => () =>
    history.push(
      planType === 'payment'
        ? `/settings/workflows/payment/edit/${resource.id}`
        : `/settings/workflows/recovery-plans/edit/${resource.id}`,
    );

  return (
    <Group gap="xs">
      {usedBy.map(resource => (
        <Badge
          key={resource.id}
          size="sm"
          radius="sm"
          variant="light"
          tt="none"
          style={{ cursor: 'pointer' }}
          onClick={goToUsedByResource(resource)}
        >
          {resource.name}
        </Badge>
      ))}
    </Group>
  );
};
